import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc.jsx';
import { LEGAL } from '../data/legal.js';
import { CONTACT } from '../data/contact.js';

export default function TermsPage() {
  return (
    <LegalDoc
      intro={`These terms cover your use of this website. They are not the agreement for landscaping work itself — that is set out in the written estimate or contract you sign with ${LEGAL.business}.`}
      contactLead="If you have questions about these Terms of Service, reach us here:"
    >
      <h2>1. Acceptance of these terms</h2>
      <p>
        By visiting or using this website, you agree to these Terms of Service and to our{' '}
        <Link to="/privacy">Privacy Policy</Link>. If you do not agree, please don't use the site.
      </p>

      <h2>2. What this website is</h2>
      <p>
        This site is an informational and marketing site for {LEGAL.business}, serving{' '}
        {CONTACT.serviceArea}. It describes the services we offer and shows examples of past work. You
        can't book, order, or pay for services through this site — everything starts with a conversation.
      </p>

      <h2>3. Quotes, estimates, and scheduling</h2>
      <ul>
        <li>
          Nothing on this website is a binding offer, a fixed price, or a guarantee of availability.
        </li>
        <li>
          Quotes are free, and typically require a look at the property. Any figure given before we see
          the site is a rough estimate and may change once we do.
        </li>
        <li>
          A quote becomes a job only when both sides agree in writing on scope and price. That written
          estimate or contract — not this website — governs the work, payment terms, warranties, and
          cancellation.
        </li>
        <li>
          Scheduling depends on weather, ground conditions, material availability, and workload. Dates
          discussed before a job is booked are targets, not commitments.
        </li>
      </ul>

      <h2>4. Photos and project examples</h2>
      <p>
        Photos on this site show real work we've done or materials representative of it. Every property is
        different — soil, drainage, slope, sun, season, and materials all affect the result — so the
        photos are examples, not a promise that your project will look identical.
      </p>

      <h2>5. Accuracy of information</h2>
      <p>
        We work to keep the site accurate and current, but service descriptions, availability, and pricing
        information can change without notice, and errors happen. Please confirm anything you're relying
        on by contacting us directly.
      </p>

      <h2>6. Our content</h2>
      <p>
        The text, photos, layout, logo, and business name on this site belong to {LEGAL.business} or are
        used with permission, and are protected by copyright and trademark law. You may view, print, and
        share pages for your own personal, non-commercial use. Don't copy, republish, or use our photos,
        logo, or content for another business or listing without our written permission.
      </p>

      <h2>7. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the site for any unlawful purpose or in a way that could damage or disable it.</li>
        <li>Attempt to gain unauthorized access to the site, its host, or related systems.</li>
        <li>Scrape, harvest, or bulk-download content, or use automated tools that overload the site.</li>
        <li>Impersonate {LEGAL.business} or misrepresent your affiliation with us.</li>
      </ul>

      <h2>8. Third-party links</h2>
      <p>
        This site links to outside services, including our Facebook page. We don't control those sites and
        aren't responsible for their content, availability, or practices. Following a link is at your own
        risk.
      </p>

      <h2>9. Disclaimer</h2>
      <p>
        This website is provided "as is" and "as available," without warranties of any kind, express or
        implied, including any implied warranties of merchantability, fitness for a particular purpose, or
        non-infringement. We don't warrant that the site will be uninterrupted, error-free, or free of
        harmful components. This disclaimer applies to the website only — it does not limit any warranty
        we give in a signed estimate or contract for actual work performed.
      </p>

      <h2>10. Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {LEGAL.business} is not liable for any indirect,
        incidental, special, or consequential damages arising out of your use of, or inability to use,
        this website — including lost time, lost profits, or damages from relying on information posted
        here. Nothing in these terms limits liability that cannot be limited under applicable law.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless {LEGAL.business} and its owner, employees, and
        subcontractors from claims, damages, and reasonable costs arising out of your misuse of this
        website or your violation of these terms.
      </p>

      <h2>12. Governing law</h2>
      <p>
        These terms are governed by the laws of the State of {LEGAL.governingState}, without regard to its
        conflict-of-laws rules. Any dispute about this website will be brought in the state or federal
        courts located in {LEGAL.governingState}, and you agree to that venue.
      </p>

      <h2>13. Changes to these terms</h2>
      <p>
        We may update these terms as the site or the business changes. The "last updated" date at the top
        of this page shows when they last changed, and continuing to use the site after a change means you
        accept the updated terms.
      </p>

      <h2>14. Severability</h2>
      <p>
        If any part of these terms is found unenforceable, the rest stays in effect, and the unenforceable
        part is applied as closely as possible to its original intent.
      </p>

      <h2>15. Ready to talk about a project?</h2>
      <p>
        Head to the <Link to="/contact">contact page</Link> or call{' '}
        <a href={`tel:${CONTACT.phoneTel}`}>{CONTACT.phoneDisplay}</a> for a free quote.
      </p>
    </LegalDoc>
  );
}
